import React from 'react';
import { LogOut, Menu } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Images } from '@assets';
import { useStudentTheme } from '@context/StudentThemeContext';
import { ThemeToggle } from './ThemeToggle';

interface JourneyTopBarProps {
  /** Desktop: collapse/expand the rail. Mobile/tablet: open/close the drawer. */
  onToggleNav: () => void;
  onLogout: () => void;
  title?: React.ReactNode;
}

export const JourneyTopBar: React.FC<JourneyTopBarProps> = ({ onToggleNav, onLogout, title }) => {
  const { theme } = useStudentTheme();
  const { t } = useTranslation('journey');
  return (
    <header className="sp-shell__topbar">
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
        <button
          type="button"
          className="sp-iconbtn"
          onClick={onToggleNav}
          aria-label={t('shell.toggleNav', 'Toggle navigation')}
          title={t('shell.toggleNav', 'Toggle navigation')}
          style={{ display: 'inline-flex' }}
        >
          <Menu size={20} />
        </button>
        <img
          src={Images.tpaLogo}
          alt="The Purpose Academy"
          style={{ height: 26, width: 'auto', objectFit: 'contain' }}
          className={theme === 'dark' ? '' : 'invert brightness-90 hue-rotate-[220deg]'}
          data-hide-on-desktop
        />
        {title && <span className="sp-subheading" style={{ marginLeft: 4, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{title}</span>}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <ThemeToggle />
        <button type="button" className="sp-iconbtn" onClick={onLogout} aria-label={t('shell.logout', 'Log out')} title={t('shell.logout', 'Log out')}>
          <LogOut size={18} />
        </button>
      </div>
    </header>
  );
};
